<template>
  <div class="seminar">
    <img class="line" alt="Line" src="/pic/online-seminar/line.svg" />
    <section class="seminar__header">
      <img class="line-left" alt="Line" src="/pic/online-seminar/arrow-left.svg" />
      <img class="line-md" alt="Line" src="/pic/online-seminar/arrow-md.png" />
      <div class="seminar__header__wrapper">
        <h1 class="mt-2 mb-2">
          Программа онлайн-семинаров &laquo;Жизненный цикл экспортного проекта&raquo;
        </h1>
        <div class="content_20">
          Хотите заявить о своей продукции на весь мир, но не знаете, как организовать экспорт?<br/>
          Или уже экспортируете, но желаете чувствовать себя увереннее в мире международной торговли?<br/><br/>
          Встречайте обновленную программу экспортных семинаров &laquo;Жизненный цикл экспортного проекта&raquo; - теперь в удобном онлайн-формате!
        </div>
        <link-target target="_blank" link="https://www.exportcenter.ru/events_exportedu/" class="mt-3">
          Записаться на семинар
        </link-target>
      </div>
    </section>
    <section class="seminar__why" style="position: relative;">
      <img style="width:77rem; right: 87.4rem; position: absolute; margin-right: 80px;" class="d-none d-lg-block" alt="Line" src="/pic/online-seminar/cover-why.png" />
      <div class="container-shadow p-64 fill-white">
        <div class="seminar__subheader">
          <svg width="84" height="85" viewBox="0 0 84 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M77 60.1663H7C6.07174 60.1663 5.1815 60.535 4.52513 61.1914C3.86875 61.8478 3.5 62.738 3.5 63.6663C3.5 64.5945 3.86875 65.4848 4.52513 66.1411C5.1815 66.7975 6.07174 67.1663 7 67.1663H77C77.9283 67.1663 78.8185 66.7975 79.4749 66.1411C80.1313 65.4848 80.5 64.5945 80.5 63.6663C80.5 62.738 80.1313 61.8478 79.4749 61.1914C78.8185 60.535 77.9283 60.1663 77 60.1663ZM77 74.1663H7C6.07174 74.1663 5.1815 74.535 4.52513 75.1914C3.86875 75.8478 3.5 76.738 3.5 77.6663C3.5 78.5945 3.86875 79.4848 4.52513 80.1411C5.1815 80.7975 6.07174 81.1663 7 81.1663H77C77.9283 81.1663 78.8185 80.7975 79.4749 80.1411C80.1313 79.4848 80.5 78.5945 80.5 77.6663C80.5 76.738 80.1313 75.8478 79.4749 75.1914C78.8185 74.535 77.9283 74.1663 77 74.1663ZM21 25.1663C20.3078 25.1663 19.6311 25.3715 19.0555 25.7561C18.4799 26.1407 18.0313 26.6873 17.7664 27.3269C17.5015 27.9664 17.4322 28.6701 17.5673 29.3491C17.7023 30.028 18.0356 30.6516 18.5251 31.1411C19.0146 31.6306 19.6383 31.964 20.3172 32.099C20.9961 32.2341 21.6999 32.1647 22.3394 31.8998C22.9789 31.6349 23.5256 31.1863 23.9101 30.6108C24.2947 30.0352 24.5 29.3585 24.5 28.6663C24.5 27.738 24.1313 26.8478 23.4749 26.1914C22.8185 25.535 21.9283 25.1663 21 25.1663ZM70 4.16626H14C11.2152 4.16626 8.54451 5.27251 6.57538 7.24164C4.60625 9.21077 3.5 11.8815 3.5 14.6663V42.6663C3.5 45.451 4.60625 48.1217 6.57538 50.0909C8.54451 52.06 11.2152 53.1663 14 53.1663H70C72.7848 53.1663 75.4555 52.06 77.4246 50.0909C79.3938 48.1217 80.5 45.451 80.5 42.6663V14.6663C80.5 11.8815 79.3938 9.21077 77.4246 7.24164C75.4555 5.27251 72.7848 4.16626 70 4.16626ZM73.5 42.6663C73.5 43.5945 73.1313 44.4848 72.4749 45.1411C71.8185 45.7975 70.9283 46.1663 70 46.1663H14C13.0717 46.1663 12.1815 45.7975 11.5251 45.1411C10.8687 44.4848 10.5 43.5945 10.5 42.6663V14.6663C10.5 13.738 10.8687 12.8478 11.5251 12.1914C12.1815 11.535 13.0717 11.1663 14 11.1663H70C70.9283 11.1663 71.8185 11.535 72.4749 12.1914C73.1313 12.8478 73.5 13.738 73.5 14.6663V42.6663ZM42 18.1663C39.9233 18.1663 37.8932 18.7821 36.1665 19.9358C34.4398 21.0896 33.094 22.7295 32.2993 24.6481C31.5045 26.5667 31.2966 28.6779 31.7018 30.7147C32.1069 32.7515 33.1069 34.6224 34.5754 36.0909C36.0438 37.5593 37.9148 38.5594 39.9516 38.9645C41.9884 39.3697 44.0996 39.1617 46.0182 38.367C47.9368 37.5723 49.5767 36.2265 50.7304 34.4997C51.8842 32.773 52.5 30.743 52.5 28.6663C52.5 25.8815 51.3938 23.2108 49.4246 21.2416C47.4555 19.2725 44.7848 18.1663 42 18.1663ZM42 32.1663C41.3078 32.1663 40.6311 31.961 40.0555 31.5764C39.4799 31.1918 39.0313 30.6452 38.7664 30.0057C38.5015 29.3661 38.4322 28.6624 38.5673 27.9834C38.7023 27.3045 39.0356 26.6809 39.5251 26.1914C40.0146 25.7019 40.6383 25.3686 41.3172 25.2335C41.9961 25.0985 42.6999 25.1678 43.3394 25.4327C43.9789 25.6976 44.5256 26.1462 44.9101 26.7218C45.2947 27.2973 45.5 27.974 45.5 28.6663C45.5 29.5945 45.1312 30.4848 44.4749 31.1411C43.8185 31.7975 42.9283 32.1663 42 32.1663ZM63 25.1663C62.3078 25.1663 61.6311 25.3715 61.0555 25.7561C60.4799 26.1407 60.0313 26.6873 59.7664 27.3269C59.5015 27.9664 59.4322 28.6701 59.5673 29.3491C59.7023 30.028 60.0356 30.6516 60.5251 31.1411C61.0146 31.6306 61.6382 31.964 62.3172 32.099C62.9961 32.2341 63.6998 32.1647 64.3394 31.8998C64.9789 31.6349 65.5256 31.1863 65.9101 30.6108C66.2947 30.0352 66.5 29.3585 66.5 28.6663C66.5 27.738 66.1313 26.8478 65.4749 26.1914C64.8185 25.535 63.9283 25.1663 63 25.1663Z" fill="#002E5E"/>
          </svg>
          <h2 style="color: #002E5E;">
            Почему именно экспортные онлайн-семинары?
          </h2>
        </div>
        <cube-list :list="[
            'все тонкости реализации каждого этапа экспортного проекта в одной программе',
            'актуальность материала',
            'насыщенность семинаров практическими заданиями и кейсами',
            'удобный онлайн-формат. Если вдруг вы пропустите семинар – зарегистрированным слушателям предоставляется запись',
            'бесплатное участие<br/><small>* - реализуется за счет средств государственного бюджета</small>'
        ]" />
        <p class="text-blue-03 content_14 mt-4">Продолжительность каждого онлайн-семинара - до 6 часов.</p>
      </div>
    </section>
    <section class="seminar__why key">
      <div class="container-shadow p-64 fill-white">
        <div class="seminar__subheader">
          <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M36 32.1663C35.0718 32.1663 34.1815 32.535 33.5251 33.1914C32.8688 33.8478 32.5 34.738 32.5 35.6663V46.1663C32.5 47.0945 32.8688 47.9848 33.5251 48.6411C34.1815 49.2975 35.0718 49.6663 36 49.6663C36.9283 49.6663 37.8185 49.2975 38.4749 48.6411C39.1313 47.9848 39.5 47.0945 39.5 46.1663V35.6663C39.5 34.738 39.1313 33.8478 38.4749 33.1914C37.8185 32.535 36.9283 32.1663 36 32.1663ZM36 21.6663C35.3078 21.6663 34.6311 21.8715 34.0555 22.2561C33.4799 22.6407 33.0313 23.1873 32.7664 23.8269C32.5015 24.4664 32.4322 25.1701 32.5673 25.8491C32.7023 26.528 33.0357 27.1516 33.5251 27.6411C34.0146 28.1306 34.6383 28.464 35.3172 28.599C35.9961 28.7341 36.6999 28.6647 37.3394 28.3998C37.979 28.1349 38.5256 27.6863 38.9102 27.1108C39.2948 26.5352 39.5 25.8585 39.5 25.1663C39.5 24.238 39.1313 23.3478 38.4749 22.6914C37.8185 22.035 36.9283 21.6663 36 21.6663ZM36 0.66626C31.4038 0.66626 26.8525 1.57156 22.6061 3.33048C18.3597 5.08939 14.5013 7.66747 11.2513 10.9175C4.68751 17.4813 1.00002 26.3837 1.00002 35.6663C0.969422 43.7482 3.76779 51.5861 8.91002 57.8213L1.91002 64.8213C1.42437 65.3134 1.09538 65.9384 0.964571 66.6174C0.833762 67.2964 0.906991 67.9989 1.17502 68.6363C1.46572 69.266 1.93698 69.7952 2.52898 70.1566C3.12098 70.5181 3.80702 70.6954 4.50002 70.6663H36C45.2826 70.6663 54.185 66.9788 60.7488 60.415C67.3125 53.8512 71 44.9488 71 35.6663C71 26.3837 67.3125 17.4813 60.7488 10.9175C54.185 4.35375 45.2826 0.66626 36 0.66626ZM36 63.6663H12.935L16.19 60.4113C16.5207 60.0871 16.7838 59.7006 16.9641 59.274C17.1443 58.8474 17.2381 58.3893 17.24 57.9263C17.2269 57.0031 16.8495 56.1225 16.19 55.4763C11.6071 50.8984 8.75313 44.8731 8.11444 38.427C7.47575 31.9809 9.09182 25.5128 12.6873 20.1246C16.2828 14.7364 21.6353 10.7615 27.8328 8.87716C34.0304 6.99282 40.6895 7.31558 46.6758 9.79046C52.662 12.2653 57.605 16.7392 60.6626 22.4499C63.7201 28.1605 64.7031 34.7547 63.444 41.1088C62.1849 47.4629 58.7616 53.1839 53.7574 57.2971C48.7532 61.4103 42.4777 63.6612 36 63.6663Z" fill="#002E5E"/>
          </svg>
          <h2 style="color: #002E5E;">
            Ключевая ценность программы
          </h2>
        </div>
        <div class="content_18 text-blue-03">
          Семинары «Жизненного цикла экспортного проекта» помогут в логичной последовательности усвоить все тонкости организации экспорта и наглядно продемонстрируют, с чем экспортеру предстоит работать на практике.
        </div>
      </div>
      <img style="width:66.2rem;  margin-left: 80px;" class="d-none d-lg-block" alt="Line" src="/pic/online-seminar/cover-key.png" />
    </section>
    <section class="seminar__why what">
      <img style="max-height: 80%; margin-right: 80px;" class="d-none d-lg-block" alt="Line" src="/pic/online-seminar/skyscrapers.jpg" />
      <div class="container-shadow p-64 fill-white">
        <div class="seminar__subheader">
          <svg width="84" height="85" viewBox="0 0 84 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M75.2151 36.3313L71.7151 34.4063L40.2151 16.9063H39.8301C39.6155 16.8156 39.3928 16.7453 39.1651 16.6963H38.5001H37.8701C37.6309 16.7453 37.3967 16.8156 37.1701 16.9063H36.7851L5.28506 34.4063C4.74642 34.7116 4.29839 35.1542 3.98668 35.6892C3.67497 36.2241 3.51074 36.8322 3.51074 37.4513C3.51074 38.0704 3.67497 38.6785 3.98668 39.2134C4.29839 39.7483 4.74642 40.191 5.28506 40.4963L14.0001 45.3263V61.9163C14.0001 64.7011 15.1063 67.3718 17.0754 69.3409C19.0446 71.31 21.7153 72.4163 24.5001 72.4163H52.5001C55.2848 72.4163 57.9556 71.31 59.9247 69.3409C61.8938 67.3718 63.0001 64.7011 63.0001 61.9163V45.3263L70.0001 41.4063V51.4163C70.0001 52.3445 70.3688 53.2348 71.0252 53.8912C71.6816 54.5475 72.5718 54.9163 73.5001 54.9163C74.4283 54.9163 75.3186 54.5475 75.9749 53.8912C76.6313 53.2348 77.0001 52.3445 77.0001 51.4163V39.3763C76.999 38.7561 76.8332 38.1473 76.5195 37.6123C76.2059 37.0773 75.7557 36.6352 75.2151 36.3313ZM56.0001 61.9163C56.0001 62.8445 55.6313 63.7348 54.9749 64.3912C54.3186 65.0475 53.4283 65.4163 52.5001 65.4163H24.5001C23.5718 65.4163 22.6816 65.0475 22.0252 64.3912C21.3688 63.7348 21.0001 62.8445 21.0001 61.9163V49.2113L36.7851 57.9613L37.3101 58.1713H37.6251C37.9156 58.2079 38.2095 58.2079 38.5001 58.1713C38.7906 58.2079 39.0845 58.2079 39.3751 58.1713H39.6901C39.8759 58.1321 40.0535 58.0611 40.2151 57.9613L56.0001 49.2113V61.9163ZM38.5001 50.9263L14.2101 37.4163L38.5001 23.9063L62.7901 37.4163L38.5001 50.9263Z" fill="#002E5E"/>
          </svg>
          <h2 style="color: #002E5E;">
            Кто будет вас обучать:
          </h2>
        </div>
        <div class="content_18" style="color: #002E5E;">
          <p>Тренерами семинаров являются эксперты-действующие практики, успешно реализующие и сопровождающие экспортные сделки российских компаний на зарубежных рынках последние 15 лет.</p>
          <p>Наши тренеры:</p>
        </div>
        <cube-list :list="[
            'работают со множеством отраслей, в том числе всеми приоритетными экспортными отраслями',
            'в совершенстве знают весь перечень продуктов Группы РЭЦ и возможности их примения',
            'просто и интересно расскажут о сложном, ответят на все вопросы и развеют любые сомнения'
        ]" />
      </div>
    </section>
    <section class="seminar__topics">
      <div class="topics-container">
        <div class="row">
          <div class="seminar__subheader col-md-8">
            <svg width="64" height="71" viewBox="0 0 64 71" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M46 63.6663H18C15.2152 63.6663 12.5445 62.56 10.5754 60.5909C8.60625 58.6217 7.5 55.951 7.5 53.1663V18.1663C7.5 17.238 7.13125 16.3478 6.47487 15.6914C5.8185 15.035 4.92826 14.6663 4 14.6663C3.07174 14.6663 2.1815 15.035 1.52513 15.6914C0.868749 16.3478 0.5 17.238 0.5 18.1663V53.1663C0.5 57.8075 2.34374 62.2587 5.62563 65.5406C8.90752 68.8225 13.3587 70.6663 18 70.6663H46C46.9283 70.6663 47.8185 70.2975 48.4749 69.6411C49.1313 68.9848 49.5 68.0945 49.5 67.1663C49.5 66.238 49.1313 65.3478 48.4749 64.6914C47.8185 64.035 46.9283 63.6663 46 63.6663ZM25 39.1663C25 40.0945 25.3687 40.9848 26.0251 41.6411C26.6815 42.2975 27.5717 42.6663 28.5 42.6663H46C46.9283 42.6663 47.8185 42.2975 48.4749 41.6411C49.1313 40.9848 49.5 40.0945 49.5 39.1663C49.5 38.238 49.1313 37.3478 48.4749 36.6914C47.8185 36.035 46.9283 35.6663 46 35.6663H28.5C27.5717 35.6663 26.6815 36.035 26.0251 36.6914C25.3687 37.3478 25 38.238 25 39.1663ZM63.5 24.9563C63.4635 24.6347 63.3932 24.318 63.29 24.0113V23.6963C63.1217 23.3364 62.8972 23.0056 62.625 22.7163L41.625 1.71626C41.3357 1.44402 41.0049 1.21954 40.645 1.05126C40.5405 1.03642 40.4345 1.03642 40.33 1.05126C39.9745 0.847354 39.5818 0.716464 39.175 0.66626H25C22.2152 0.66626 19.5445 1.77251 17.5754 3.74164C15.6062 5.71077 14.5 8.38149 14.5 11.1663V46.1663C14.5 48.951 15.6062 51.6217 17.5754 53.5909C19.5445 55.56 22.2152 56.6663 25 56.6663H53C55.7848 56.6663 58.4555 55.56 60.4246 53.5909C62.3938 51.6217 63.5 48.951 63.5 46.1663V25.1663C63.5 25.1663 63.5 25.1663 63.5 24.9563ZM42.5 12.6013L51.565 21.6663H46C45.0717 21.6663 44.1815 21.2975 43.5251 20.6411C42.8688 19.9848 42.5 19.0945 42.5 18.1663V12.6013ZM56.5 46.1663C56.5 47.0945 56.1313 47.9848 55.4749 48.6411C54.8185 49.2975 53.9283 49.6663 53 49.6663H25C24.0717 49.6663 23.1815 49.2975 22.5251 48.6411C21.8687 47.9848 21.5 47.0945 21.5 46.1663V11.1663C21.5 10.238 21.8687 9.34776 22.5251 8.69139C23.1815 8.03501 24.0717 7.66626 25 7.66626H35.5V18.1663C35.5095 19.3603 35.7225 20.5439 36.13 21.6663H28.5C27.5717 21.6663 26.6815 22.035 26.0251 22.6914C25.3687 23.3478 25 24.238 25 25.1663C25 26.0945 25.3687 26.9848 26.0251 27.6411C26.6815 28.2975 27.5717 28.6663 28.5 28.6663H56.5V46.1663Z" fill="#002E5E"/>
            </svg>
            <h2 style="color: #002E5E;">Темы и содержание:</h2>
          </div>
          <div class="col-md-4 text-right">
            <a href="javascript:void(0)" @click="prevSlide">
              <svg style="margin-bottom: -30px;" width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M53 31.6662H45.41L48.71 28.3762C48.8983 28.1879 49.0041 27.9325 49.0041 27.6662C49.0041 27.3999 48.8983 27.1445 48.71 26.9562C48.5217 26.7679 48.2663 26.6621 48 26.6621C47.7337 26.6621 47.4783 26.7679 47.29 26.9562L42.29 31.9562C42.199 32.0513 42.1276 32.1634 42.08 32.2862C41.98 32.5297 41.98 32.8027 42.08 33.0462C42.1276 33.169 42.199 33.2811 42.29 33.3762L47.29 38.3762C47.383 38.4699 47.4936 38.5443 47.6154 38.5951C47.7373 38.6459 47.868 38.672 48 38.672C48.132 38.672 48.2627 38.6459 48.3846 38.5951C48.5065 38.5443 48.6171 38.4699 48.71 38.3762C48.8037 38.2832 48.8781 38.1726 48.9289 38.0508C48.9797 37.9289 49.0058 37.7982 49.0058 37.6662C49.0058 37.5342 48.9797 37.4035 48.9289 37.2816C48.8781 37.1598 48.8037 37.0492 48.71 36.9562L45.41 33.6662H53C53.2652 33.6662 53.5196 33.5608 53.7071 33.3733C53.8947 33.1858 54 32.9314 54 32.6662C54 32.401 53.8947 32.1466 53.7071 31.9591C53.5196 31.7716 53.2652 31.6662 53 31.6662Z" fill="#002E5E"/>
                <g filter="url(#filter0_ddd_274_2557)">
                  <circle cx="48" cy="32.6663" r="22.5" stroke="#002E5E" stroke-width="3"/>
                </g>
                <defs>
                  <filter id="filter0_ddd_274_2557" x="0" y="0.66626" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_274_2557"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="3"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_274_2557" result="effect2_dropShadow_274_2557"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="16"/>
                    <feGaussianBlur stdDeviation="12"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                    <feBlend mode="normal" in2="effect2_dropShadow_274_2557" result="effect3_dropShadow_274_2557"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_274_2557" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </a>
            <a href="javascript:void(0)" @click="nextSlide">
              <svg style="margin-bottom: -30px;" width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ddd_274_2554)">
                  <circle cx="48" cy="32.6663" r="22.5" stroke="#002E5E" stroke-width="3"/>
                </g>
                <path d="M53.92 32.2862C53.8724 32.1634 53.801 32.0513 53.71 31.9562L48.71 26.9562C48.6168 26.863 48.5061 26.789 48.3842 26.7385C48.2624 26.6881 48.1319 26.6621 48 26.6621C47.7337 26.6621 47.4783 26.7679 47.29 26.9562C47.1968 27.0494 47.1228 27.1601 47.0723 27.282C47.0219 27.4038 46.9959 27.5343 46.9959 27.6662C46.9959 27.9325 47.1017 28.1879 47.29 28.3762L50.59 31.6662H43C42.7348 31.6662 42.4804 31.7716 42.2929 31.9591C42.1054 32.1466 42 32.401 42 32.6662C42 32.9314 42.1054 33.1858 42.2929 33.3733C42.4804 33.5608 42.7348 33.6662 43 33.6662H50.59L47.29 36.9562C47.1963 37.0492 47.1219 37.1598 47.0711 37.2816C47.0203 37.4035 46.9942 37.5342 46.9942 37.6662C46.9942 37.7982 47.0203 37.9289 47.0711 38.0508C47.1219 38.1726 47.1963 38.2832 47.29 38.3762C47.383 38.4699 47.4936 38.5443 47.6154 38.5951C47.7373 38.6459 47.868 38.672 48 38.672C48.132 38.672 48.2627 38.6459 48.3846 38.5951C48.5064 38.5443 48.617 38.4699 48.71 38.3762L53.71 33.3762C53.801 33.2811 53.8724 33.169 53.92 33.0462C54.02 32.8027 54.02 32.5297 53.92 32.2862Z" fill="#002E5E"/>
                <defs>
                  <filter id="filter0_ddd_274_2554" x="0" y="0.66626" width="96" height="96" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="0.5"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_274_2554"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="3"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                    <feBlend mode="normal" in2="effect1_dropShadow_274_2554" result="effect2_dropShadow_274_2554"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="16"/>
                    <feGaussianBlur stdDeviation="12"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                    <feBlend mode="normal" in2="effect2_dropShadow_274_2554" result="effect3_dropShadow_274_2554"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_274_2554" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </a>
          </div>
        </div>
        <div>
          <carousel
              :loop="true"
              :per-page="1"
              :pagination-enabled="false"
              :scroll-per-page="false"
              :navigation-enabled="false"
              ref="carousel"
              :per-page-custom="[[320, 1], [420, 1], [768, 2], [1200, 3]]">
            <slide v-for="(topic, idx) in topics" :key="idx">
              <div class="topic-card container-shadow">
                <h3 class="text-blue-03">{{ topic.title }}</h3>
                <cube-list :list="topic.points"/>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </section>
    <section class="seminar__calendar">
      <div class="calendar-wrapper">
        <div class="seminar__subheader">
          <svg width="84" height="85" viewBox="0 0 84 85" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42 67.1663C42.6922 67.1663 43.3689 66.961 43.9445 66.5764C44.5201 66.1918 44.9687 65.6452 45.2336 65.0056C45.4985 64.3661 45.5678 63.6624 45.4327 62.9834C45.2977 62.3045 44.9644 61.6809 44.4749 61.1914C43.9854 60.7019 43.3617 60.3686 42.6828 60.2335C42.0039 60.0985 41.3001 60.1678 40.6606 60.4327C40.0211 60.6976 39.4744 61.1462 39.0899 61.7218C38.7053 62.2973 38.5 62.974 38.5 63.6663C38.5 64.5945 38.8687 65.4848 39.5251 66.1411C40.1815 66.7975 41.0717 67.1663 42 67.1663ZM59.5 67.1663C60.1922 67.1663 60.8689 66.961 61.4445 66.5764C62.0201 66.1918 62.4687 65.6452 62.7336 65.0056C62.9985 64.3661 63.0678 63.6624 62.9327 62.9834C62.7977 62.3045 62.4644 61.6809 61.9749 61.1914C61.4854 60.7019 60.8618 60.3686 60.1828 60.2335C59.5039 60.0985 58.8002 60.1678 58.1606 60.4327C57.5211 60.6976 56.9744 61.1462 56.5899 61.7218C56.2053 62.2973 56 62.974 56 63.6663C56 64.5945 56.3687 65.4848 57.0251 66.1411C57.6815 66.7975 58.5717 67.1663 59.5 67.1663ZM59.5 53.1663C60.1922 53.1663 60.8689 52.961 61.4445 52.5764C62.0201 52.1918 62.4687 51.6452 62.7336 51.0057C62.9985 50.3661 63.0678 49.6624 62.9327 48.9834C62.7977 48.3045 62.4644 47.6809 61.9749 47.1914C61.4854 46.7019 60.8618 46.3686 60.1828 46.2335C59.5039 46.0985 58.8002 46.1678 58.1606 46.4327C57.5211 46.6976 56.9744 47.1462 56.5899 47.7218C56.2053 48.2973 56 48.974 56 49.6663C56 50.5945 56.3687 51.4848 57.0251 52.1411C57.6815 52.7975 58.5717 53.1663 59.5 53.1663ZM42 53.1663C42.6922 53.1663 43.3689 52.961 43.9445 52.5764C44.5201 52.1918 44.9687 51.6452 45.2336 51.0057C45.4985 50.3661 45.5678 49.6624 45.4327 48.9834C45.2977 48.3045 44.9644 47.6809 44.4749 47.1914C43.9854 46.7019 43.3617 46.3686 42.6828 46.2335C42.0039 46.0985 41.3001 46.1678 40.6606 46.4327C40.0211 46.6976 39.4744 47.1462 39.0899 47.7218C38.7053 48.2973 38.5 48.974 38.5 49.6663C38.5 50.5945 38.8687 51.4848 39.5251 52.1411C40.1815 52.7975 41.0717 53.1663 42 53.1663ZM66.5 11.1663H63V7.66626C63 6.738 62.6313 5.84776 61.9749 5.19139C61.3185 4.53501 60.4283 4.16626 59.5 4.16626C58.5717 4.16626 57.6815 4.53501 57.0251 5.19139C56.3687 5.84776 56 6.738 56 7.66626V11.1663H28V7.66626C28 6.738 27.6313 5.84776 26.9749 5.19139C26.3185 4.53501 25.4283 4.16626 24.5 4.16626C23.5717 4.16626 22.6815 4.53501 22.0251 5.19139C21.3687 5.84776 21 6.738 21 7.66626V11.1663H17.5C14.7152 11.1663 12.0445 12.2725 10.0754 14.2416C8.10625 16.2108 7 18.8815 7 21.6663V70.6663C7 73.451 8.10625 76.1217 10.0754 78.0909C12.0445 80.06 14.7152 81.1663 17.5 81.1663H66.5C69.2848 81.1663 71.9555 80.06 73.9246 78.0909C75.8938 76.1217 77 73.451 77 70.6663V21.6663C77 18.8815 75.8938 16.2108 73.9246 14.2416C71.9555 12.2725 69.2848 11.1663 66.5 11.1663ZM70 70.6663C70 71.5945 69.6313 72.4848 68.9749 73.1411C68.3185 73.7975 67.4283 74.1663 66.5 74.1663H17.5C16.5717 74.1663 15.6815 73.7975 15.0251 73.1411C14.3687 72.4848 14 71.5945 14 70.6663V39.1663H70V70.6663ZM70 32.1663H14V21.6663C14 20.738 14.3687 19.8478 15.0251 19.1914C15.6815 18.535 16.5717 18.1663 17.5 18.1663H21V21.6663C21 22.5945 21.3687 23.4848 22.0251 24.1411C22.6815 24.7975 23.5717 25.1663 24.5 25.1663C25.4283 25.1663 26.3185 24.7975 26.9749 24.1411C27.6313 23.4848 28 22.5945 28 21.6663V18.1663H56V21.6663C56 22.5945 56.3687 23.4848 57.0251 24.1411C57.6815 24.7975 58.5717 25.1663 59.5 25.1663C60.4283 25.1663 61.3185 24.7975 61.9749 24.1411C62.6313 23.4848 63 22.5945 63 21.6663V18.1663H66.5C67.4283 18.1663 68.3185 18.535 68.9749 19.1914C69.6313 19.8478 70 20.738 70 21.6663V32.1663ZM24.5 53.1663C25.1922 53.1663 25.8689 52.961 26.4445 52.5764C27.0201 52.1918 27.4687 51.6452 27.7336 51.0057C27.9985 50.3661 28.0678 49.6624 27.9327 48.9834C27.7977 48.3045 27.4644 47.6809 26.9749 47.1914C26.4854 46.7019 25.8617 46.3686 25.1828 46.2335C24.5039 46.0985 23.8001 46.1678 23.1606 46.4327C22.5211 46.6976 21.9744 47.1462 21.5899 47.7218C21.2053 48.2973 21 48.974 21 49.6663C21 50.5945 21.3687 51.4848 22.0251 52.1411C22.6815 52.7975 23.5717 53.1663 24.5 53.1663ZM24.5 67.1663C25.1922 67.1663 25.8689 66.961 26.4445 66.5764C27.0201 66.1918 27.4687 65.6452 27.7336 65.0056C27.9985 64.3661 28.0678 63.6624 27.9327 62.9834C27.7977 62.3045 27.4644 61.6809 26.9749 61.1914C26.4854 60.7019 25.8617 60.3686 25.1828 60.2335C24.5039 60.0985 23.8001 60.1678 23.1606 60.4327C22.5211 60.6976 21.9744 61.1462 21.5899 61.7218C21.2053 62.2973 21 62.974 21 63.6663C21 64.5945 21.3687 65.4848 22.0251 66.1411C22.6815 66.7975 23.5717 67.1663 24.5 67.1663Z" fill="#002E5E"/>
          </svg>
          <div class="d-flex align-items-center">
            <h2 style="color: #002E5E;">Регистрируйтесь на ближайший семинар!</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6" v-for="(event, index) in events" :key="index">
            <seminar-card :key="index" :event="event" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LinkTarget from "@/components/LinkTarget.vue";
import CubeList from "@/components/CubeList.vue";
import { Carousel, Slide } from 'vue-carousel';
import SeminarCard from "@/components/online-seminar/SeminarCard.vue";

export default {
  name: 'OnlineSeminar',
  components: {SeminarCard, CubeList, LinkTarget, Carousel, Slide},
  data() {
    return {
      currentSlide: 0,
      events: [
        {
          title: 'Маркетинг как часть экспортного проекта',
          start_datetime: '2026-02-12T10:00:00+00',
          external_link: 'https://www.exportcenter.ru/events_exportedu/817936/',
          tutors: [
            {
              fullname: 'Анна Кочемасова'
            },
            {
              fullname: 'Халида Муфтахутдинова'
            }
          ],
          cover: {
            '500x': '/pic/online-seminar/31.07.2025.jpeg',
          }
        }
      ],
      topics: [
        {
          title: 'Основы экспортной деятельности',
          points: [
            'Пошаговый анализ всего жизненного цикла экспортного проекта',
            'Алгоритм оценки готовности вашего предприятия к экспортной деятельности',
            'Рекомендации по подготовке документов, необходимых для заключения внешнеторговой сделки',
            'Порядок проверки надежности иностранного контрагента',
            'Онлайн-источники полезной для экспортеров информации'
          ]
        },
        {
          title: 'Правовые аспекты экспорта',
          points: [
            'Основные международно-правовые акты и нормы частного права, регулирующие внешнюю торговлю',
            'Структура внешнеторгового контракта',
            'Защита интеллектуальной собственности',
            'Критерии выбора квалифицированного юриста-консультанта'
          ]
        },
        {
          title: 'Финансовые инструменты экспорта',
          points: [
            'Финансовые риски экспортной деятельности и методы их минимизации',
            'Масштаб рисков экспортера в зависимости от используемого финансового инструмента',
            'Типовые условия экспортного кредитования и специфика банковских проверок экспортера и его контрагента',
            'Наиболее распространенные механизмы хеджирования валютных операций (форварды, фьючерсы и опционы)',
          ]
        },
        {
          title: 'Документационное сопровождение экспорта',
          points: [
            'Перечень документов для подготовки на разных этапах экспортного проекта',
            'Алгоритм классификации товаров по коду ТН ВЭД (Товарная номенклатура внешнеэкономической деятельности)',
            'Пример идентификации товара из списка экспортного контроля',
            'Образец заполнения паспорта сделки, справки о валютных операциях и справки о подтверждающих документах'
          ]
        },
        {
          title: 'Таможенное регулирование экспорта',
          points: [
            'Основы таможенного дела',
            'Детальный анализ таможенных процедур и ошибок, допущенных при декларировании экспортируемых товаров',
            'Правила толкования кодов ТН ВЭД и определения страны происхождения товаров',
            'Перечень документов, необходимых для подтверждения таможенной стоимости',
            'Сравнительная таблица ведомственных и судебных апелляционных действий таможенных органов'
          ]
        },
        {
          title: 'Логистика для экспортеров',
          points: [
            'Семь критериев организации эффективной логистики',
            'Обзор российского рынка логистических услуг',
            'Образец заполнения накладной КДПГ, коносамента, авианакладной и документов, регулирующих перевозку отдельными видами транспорта',
            'Рекомендации по выбору логистического оператора и страховой компании',
            'Подборка электронных баз данных и интернет-сайтов, актуальных для экспортного логистического проекта'
          ]
        },
        {
          title: 'Контрольные процедуры в экспорте',
          points: [
            'Документационное обеспечение',
            'Основы валютного законодательства и валютная отчетность',
            'Налогообложение в экспорте',
            'Основные отличия систем налогообложения'
          ]
        }
      ]
    }
  },
  mounted() {
    this.$parent.init()
  },
  methods: {
    nextSlide() {
      this.$refs.carousel.handleNavigation('forward');
    },
    prevSlide() {
      this.$refs.carousel.handleNavigation('backward');
    },
  },

}
</script>

<style lang="scss">
.seminar {
  position: relative;
  padding-top: 18rem;

  .line {
    position: absolute;
    top: 42.5rem;
    right: 7.2rem;
    width: 135.1rem;
    z-index: 10;
  }

  section {
    display: flex;
    justify-content: center;
    img {
      z-index: 10;
      max-height: 100%;
    }
  }

  &__header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70rem;
    background: url(/pic/online-seminar/ship.png) center center no-repeat;
    background-size: cover;

    .link-target {
      color: #fff;
    }

    .line-md {
      display: none;
    }

    .line-left {
      position: absolute;
      left: 64px;
      bottom: -2rem;
      width: 37rem;
      z-index: 10;
    }

    &__wrapper {
      width: 100rem;
      z-index: 20;
      color: #fff;

      h1 {
        font-weight: bold;
      }

      font-weight: 300;
    }
  }

  &__subheader {
    display: flex;
    align-items: center;
    gap: 2rem;

    h2 {
      font-size: 3.2rem;
      line-height: 1;
    }

    margin-bottom: 2rem;
  }

  &__why {
    width: 175rem;
    height: 75rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end !important;

    .container-shadow {
      width: 87.4rem;
      z-index: 25;
    }

    &.key {
      height: 38.4rem;
      justify-content: flex-start !important;
    }
    &.what {
      height: 57.8rem;
    }
  }

  &__topics {
    margin: 0 auto;
    width: 165rem;

    .VueCarousel-wrapper {
      padding-bottom: 50px;
    }

    .topics-container {
      max-width: 100%;
      z-index: 20;
      padding-top: 20px;

      h3 {
        font-size: 2.4rem;
        margin-bottom: 3.2rem;
      }

      .topic-card {
        padding: 4.8rem 6.4rem 4.4rem;
        background: rgba(255,255,255, 0.8);
        margin: 0 2rem 5rem;
        height: 100%;
        border: 1px solid #D6D6D6;
      }
    }
  }
  &__calendar {
    height: auto;
    margin: 0 auto;
    width: 165rem;
    .calendar-wrapper {
      z-index: 20;
      width: 100%;
    }
  }
}

/* Медиа-запросы */
@media (max-width: 768px) {
  .seminar {
    padding-top: 0;

    .line {
      display: none;
    }

    .line-md {
      display: block;
      position: absolute;
      width: 100%;
      bottom: 0;
      right: 20px;
      z-index: 1;
    }

    section {
      height: auto;
      width: auto;

      &.key, &.what {
        height: auto;
      }
    }

    &__header {
      margin-top: -9rem;
      padding: 0 24px;
      width: 100%;
      background: url(/pic/online-seminar/ship.png) center center no-repeat;
      background-size: cover;

      .line-left {
        display: none;
      }

      &__wrapper {
        padding-bottom: 153px;

        h1 {
          font-size: 44px;
        }
      }
    }

    &__subheader {
      align-items: flex-start;

      svg {
        height: 48px;
      }

      h2 {
        font-size: 28px;
        line-height: 1;
      }
    }

    .container-shadow {
      margin: 32px 16px 0;
      padding: 24px;
    }

    &__topics {
      margin-top: 40px;
      .VueCarousel-wrapper {
        padding-bottom: 32px;
      }
      .topics-container {
        width: 100%;
        h3 {
          font-size: 24px;
          margin-bottom: 32px;
        }
      }
    }
  }
}
</style>
